"use client";
import { useEffect } from "react";
import { useCentralizedProviderData, useMe } from "@crehana/auth";
import { useIsRenderedFromWebView } from "@crehana/react-hooks/use-is-rendered-from-webview";
import { useGetIntercomUserJwtQuery } from "./get-intercom-user-jwt.v5.generated.js";
const isProduction = 'production' === process.env.APP_ENV;
const LoadIntercom = ({ config })=>{
    const isRenderedFromReactNativeWebView = useIsRenderedFromWebView();
    const { me, loading, currentPageOrganization } = useCentralizedProviderData();
    const { me: learningMe, loading: loadingLearningMe } = useMe();
    const { loading: loadingJWT, data: dataJWT } = useGetIntercomUserJwtQuery({
        context: {
            clientName: 'v5'
        }
    });
    const intercomEnabled = config?.enabled ?? true;
    const intercomForceToLoad = config?.forceToLoad ?? false;
    const getAppId = ()=>{
        if ('production' === process.env.NODE_ENV) return 'mevliu65';
    };
    const appId = getAppId();
    useEffect(()=>{
        const noAppId = !appId;
        const isLoading = loadingJWT || loadingLearningMe || loading;
        const isLogged = me || learningMe;
        const insideB2BUrls = window.location.pathname.includes('/org/') || window.location.pathname.startsWith('/studios/');
        if (noAppId || isLoading || !isLogged || !insideB2BUrls || isRenderedFromReactNativeWebView) return;
        const intercomCustomAttributes = {};
        if (me) {
            intercomCustomAttributes.user_id = me.id.toString();
            intercomCustomAttributes.centralized_organization_id = currentPageOrganization?.id.toString() || 'unknown';
            intercomCustomAttributes.centralized_user_id = me.id.toString();
            intercomCustomAttributes.centralized_user_role = me.security.applicationRoles.find((role)=>'ROLE_SUPERADMIN' === role || 'ROLE_ADMIN' === role || 'ROLE_USER' === role) || 'ROLE_UNKNOWN';
            intercomCustomAttributes.name = me.user.fullName;
            intercomCustomAttributes.email = me.user.email;
            intercomCustomAttributes.created_at = me.user.createdAt;
            intercomCustomAttributes.company_name = currentPageOrganization?.name || 'unknown';
            intercomCustomAttributes.child_organization_slugs = me.canAccessOrganizations || [];
            if (me.security.learningSession?.userId) intercomCustomAttributes.centralized_learning_user_id = me.security.learningSession.userId;
            if (me.security.talentSession?.userId) intercomCustomAttributes.centralized_talent_user_id = me.security.talentSession.userId;
            if (dataJWT?.intercom?.get_jwt_encode?.__typename === 'JWTResponseType' && dataJWT.intercom.get_jwt_encode.jwt_encode) intercomCustomAttributes.intercom_user_jwt = dataJWT.intercom.get_jwt_encode.jwt_encode;
        } else if (learningMe) {
            intercomCustomAttributes.user_id = learningMe.originalId?.toString();
            intercomCustomAttributes.name = learningMe.fullName || '';
            intercomCustomAttributes.email = learningMe.email || '';
            intercomCustomAttributes.company_name = learningMe.organization?.name || '';
            intercomCustomAttributes.created_at = learningMe.dateJoined;
            intercomCustomAttributes.solo_learning_organization_id = learningMe.organization?.id.toString() || 'unknown';
            intercomCustomAttributes.solo_learning_user_id = learningMe.originalId?.toString();
            intercomCustomAttributes.solo_learning_user_role = learningMe.isB2BAdmin ? 'ROLE_ADMIN' : 'ROLE_USER';
        }
        if (intercomEnabled && isProduction || intercomForceToLoad) {
            const loadAndInitIntercom = async ()=>{
                const intercom = await import("@intercom/messenger-js-sdk").then((module)=>module.Intercom);
                intercom({
                    app_id: appId,
                    debug: true,
                    ...intercomCustomAttributes
                });
            };
            loadAndInitIntercom();
        }
    }, [
        me,
        loading,
        loadingJWT,
        dataJWT,
        loadingLearningMe,
        learningMe,
        currentPageOrganization
    ]);
    return null;
};
export { LoadIntercom };
